import { useQuery } from "react-query";
import { OrcamentoDados } from "../typings";
import http from "infra/http";
import { AxiosError } from "axios";

export function useListarItensCotados(id?: string) {
  return useQuery<OrcamentoDados, AxiosError>(
    `/v1/orcamento/${id}`,
    async () => {
      const { data } = await http.get<OrcamentoDados>(
        `/v1/orcamento/${id}`
      );

      return data;
    },
    { enabled: !!id }
  );
}
